import { type FormEvent, useState } from 'react';
import ShoppingCart from '@/assets/icons/ShoppingCart.svg';
import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { FormOrientation } from '@/components/Form/Form.types';
import { NumberInput } from '@/components/NumberInput';
import { usePageData } from '@/contexts/pageContext';
import { useAddToBasket } from '@/hooks/useAddToBasket';
import { getButtonLabel } from './getButtonLabel';
import { PurchaseAction } from '@/constants';

const DEFAULT_VALUE = 1;

export const PurchaseForm = () => {
  const { product } = usePageData();
  const purchaseAction = product?.purchaseAction;

  console.log('Purchase Action', purchaseAction);

  const { addToBasket, isPending } = useAddToBasket(product, 'pdp');

  const [quantity, setQuantity] = useState(DEFAULT_VALUE);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isPending) {
      const payload = {
        code: product?.sku ?? '',
        quantity: `${quantity}`,
      };

      addToBasket(payload);
    }
  };

  const buttonLabel = getButtonLabel(purchaseAction);

  // Only show Google Pay for products that can be purchased immediately
  const showGooglePay =
    purchaseAction === PurchaseAction.CanPurchase ||
    purchaseAction === PurchaseAction.BackOrder ||
    purchaseAction === PurchaseAction.PreOrder;

  return (
    <>
      <Form handleSubmit={handleSubmit} orientation={FormOrientation.Inline}>
        <NumberInput
          label="quantity"
          maxValue={product?.maxQuantity ?? 50}
          minValue={DEFAULT_VALUE}
          name="quantity"
          onChange={setQuantity}
          value={quantity}
        />
        <Button icon={<ShoppingCart />} isPending={isPending} type="submit">
          {buttonLabel}
        </Button>
      </Form>
      {showGooglePay && (
        <div
          className="quickpay"
          data-buy-now="true"
          data-product-code={product?.sku || ''}
          data-quantity={quantity.toString()}
          style={{ marginTop: '1rem' }}
        />
      )}
    </>
  );
};
